import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "select", "lineTotal"]

    connect() {
        this.updatePrice()
    }

    updatePrice() {

        // If no dropdown (product has no tiers), just use the input value
        if (!this.hasSelectTarget) {
            this.calculateLineTotal()
            return
        }

        const selectedValue = this.selectTarget.value

        // Logic: Show input ONLY if "custom" is selected
        // Otherwise, hide input and use the selected Value
        if (selectedValue === "custom") {
            this.inputTarget.classList.remove("hidden")
            this.inputTarget.readOnly = false
            this.inputTarget.required = true

            // If explicit "custom" action, maybe clear it or keep current
            if (this.inputTarget.value === "0.00") {
                this.inputTarget.value = ""
            }
        } else {
            this.inputTarget.classList.add("hidden")
            this.inputTarget.readOnly = true // Prevent editing when hidden
            this.inputTarget.required = false // Not required when hidden

            // Populate input with the dropdown value so calculation works
            // Ignore empty selection
            if (selectedValue !== "") {
                this.inputTarget.value = selectedValue
            }
        }

        this.calculateLineTotal()
    }

    calculateLineTotal() {
        const priceValue = this.inputTarget.value
        const price = parseFloat(priceValue) || 0
        const quantity = parseFloat(this.element.dataset.quantity) || 0
        const total = price * quantity

        if (this.hasLineTotalTarget) {
            if (price > 0 || priceValue === "0" || priceValue === "0.00" || priceValue === "0.0") {
                this.lineTotalTarget.textContent = `$${total.toFixed(2)}`
                this.lineTotalTarget.classList.remove("text-slate-500")
                this.lineTotalTarget.classList.add("text-slate-900", "dark:text-white")
            } else {
                this.lineTotalTarget.textContent = "Requires Input"
                this.lineTotalTarget.classList.add("text-slate-500")
                this.lineTotalTarget.classList.remove("text-slate-900", "dark:text-white")
            }
        }

        // Dispatch event bubbling up
        this.dispatch("priceChanged", { detail: { total }, bubbles: true })
    }

    // Called when user types in custom price input
    inputChanged() {
        this.calculateLineTotal()
    }
}
